'use strict';
import DataQueryList from './mx-data-query-list';

angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetViewTiles', {
	transclude: true,
	bindings: {
		parameters: '<',
		tilesConfig: '<',
		outputPreprocessors: '<',
	},
	controller: MxContentWidgetViewTilesCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-content-widget-view/list/mx-content-widget-view-tiles.html',
});

MxContentWidgetViewTilesCtrl.$inject = ['mx.shell.EventService', 'mx.shell.SideLayout', '$injector', '$element', '$scope'];

MxContentWidgetViewTilesCtrl.prototype = Object.create(DataQueryList.prototype);

function MxContentWidgetViewTilesCtrl(eventService, sideLayout, $injector, $element, $scope) {
	var vm = this;
	var container = $element.find('.mx-template-tiles--zone')[0];
	var _cachedContainerWidth = container.offsetWidth - 1;

	var tileSpacePx = 10;
	var scrollWidth = 10;
	var DEFAULT_TILE_SIZE = 300;

	vm.$onInit = function () {
		vm.type = mx.SolutionBuilderAgent.ListingType.tiles;
		vm.initialize($injector, $scope);
		if (typeof vm.outputPreprocessors === 'object') {
			angular.extend(vm.outputPreprocessors, vm.preprocessorsByName);
		}

		vm.load();

		eventService.subscribeTo(
			mx.shell.EventCodes.LayoutChanged,
			$.debounce(500, function (e, name) {
				if (name === 'sideLayoutResized') {
					if (vm.clickedItem) {
						scrollToItem(vm.clickedItem);
						delete vm.clickedItem;
					}
				} else {
					updateTilesSizes();
				}
			}),
			$scope
		);
		updateTilesSizes();
	};

	var scrollZone, contentWidgetView, tileWrapper;

	function scrollToItem(item) {
		scrollZone = scrollZone || $('.mx-search-page-scrollable-content');
		contentWidgetView = contentWidgetView || $('.mx-search-page-scrollable-content mx-content-widget-view')[0];
		tileWrapper = tileWrapper || $('.mx-search-page-scrollable-content mx-content-widget-view .mx-tile-wrapper')[0];

		var element = $('[key=' + item.Id + ']', scrollZone)[0];
		if (!element) {
			return;
		}

		if (typeof element.scrollIntoView === 'function') {
			element.scrollIntoView({ behavior: 'smooth' });
		} else {
			var top = contentWidgetView.offsetTop + tileWrapper.offsetTop + element.offsetTop;
			scrollZone.animate(
				{
					scrollTop: top,
				},
				100
			);
		}
	}

	vm.$postLink = function () {
		var sortingPanel = $element.find('mx-workspace-common-order-panel');

		angular.element('.mx-search-page-place-holder').empty().append(sortingPanel);
	};

	$scope.$watch('vm.loading', function (value) {
		vm.pagingPreprocessor.loading = value;
	});

	return vm;

	function updateTilesSizes() {
		var newContainerWidth = container.offsetWidth;
		if (newContainerWidth > 0 && newContainerWidth !== _cachedContainerWidth) {
			_cachedContainerWidth = newContainerWidth;

			$scope.$evalAsync(function () {
				var columns = getColumnsNumber(vm.tilesConfig.width, newContainerWidth);
				vm.tileWidth = Math.floor((newContainerWidth - 2 * scrollWidth) / columns) - tileSpacePx;
				vm.tileHeight = getPixelWidthByUnit(vm.tilesConfig.height, container.offsetHeight);
			});
		}
	}

	function getColumnsNumber(minTileWidth, tilesZoneWidth) {
		var availSpace = tilesZoneWidth;

		// this `isHalfSpace` is needed just for the case if open side-panel tiles shouldn't jump
		var isHalfSpace = sideLayout.visible && !sideLayout.fullScreenMode;

		if (isHalfSpace) {
			availSpace = availSpace * 2 + 8;
		} else if (availSpace % 2 !== 0) {
			availSpace += 1;
		}

		var cols = Math.floor((availSpace + tileSpacePx) / (getPixelWidthByUnit(vm.tilesConfig.width, tilesZoneWidth) + tileSpacePx));

		if (cols % 2 !== 0) {
			cols--;
		}

		return Math.max(1, isHalfSpace ? cols / 2 : cols);
	}

	function getPixelWidthByUnit(initialValue, offsetValue) {
		var value = parseFloat(initialValue);

		if (isNaN(value)) {
			return DEFAULT_TILE_SIZE;
		}

		if (initialValue.indexOf('px') !== -1) {
			return parseInt(value);
		} else if (initialValue.indexOf('%') !== -1) {
			return parseInt((offsetValue * value) / 100);
		} else if (initialValue.indexOf('rem') !== -1) {
			return parseInt(value * 10);
		} else if (initialValue.indexOf('em') !== -1) {
			var containerElem = document.getElementsByClassName('mx-template-tiles--zone')[0];
			var fontSizePoints = document.defaultView.getComputedStyle(containerElem, null).fontSize || 12;

			return parseInt((parseInt(fontSizePoints) * value) / 0.75);
		}

		return parseInt(value);
	}
}
